export default "__VITE_ASSET__BzI5SGSe__"